import { render, staticRenderFns } from "./RegisteForm.vue?vue&type=template&id=46012f44&scoped=true&"
import script from "./RegisteForm.vue?vue&type=script&lang=js&"
export * from "./RegisteForm.vue?vue&type=script&lang=js&"
import style0 from "./RegisteForm.vue?vue&type=style&index=0&id=46012f44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46012f44",
  null
  
)

export default component.exports